export const ONE_HOUR_IN_MS = 1000 * 60 * 60
export const ONE_DAY_IN_MS = ONE_HOUR_IN_MS * 24
export const APP_NAME = "Placepoint Backoffice"

const HUBSPOT_PORTAL_URL = "https://app.hubspot.com/contacts/20044102"

// HubSpot deep links per record type: 0-2 = companies (ExternalCustomerId),
// 0-1 = contacts (UserContact.ExternalContactId).
export const HUBSPOT_BASE_URL = `${HUBSPOT_PORTAL_URL}/record/0-2`
export const HUBSPOT_CONTACT_BASE_URL = `${HUBSPOT_PORTAL_URL}/record/0-1`

// Fenerum dashboard deep links (the billing sibling of the HubSpot pair).
// Both routes take Fenerum's own uuid — the account one is
// Customer/Tenant.BillingAccountUuid (mirrored lic.CustomerAccounts.
// ExternalAccountUuid), the invoice one is Invoice.ExternalInvoiceUuid.
const FENERUM_APP_URL = "https://app.fenerum.com"
export const FENERUM_ACCOUNT_BASE_URL = `${FENERUM_APP_URL}/billing/accounts`
export const FENERUM_INVOICE_BASE_URL = `${FENERUM_APP_URL}/billing/invoices`
export const FENERUM_PLAN_BASE_URL = `${FENERUM_APP_URL}/billing/licenses`
